import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { Prices } from "./Prices";

export const productPrices = typeCheckAppModule({
    NAME,
    Container: Prices,
});
